<div class="ft2-color-swatch" [style.background-color]="color">
</div>
{{color ? color : placeholder}}
